import { JBaseApi } from '../base';
import { OF } from '../../util/network';
import { ApiWrapper } from '../../types/utils';

export class JMenuApi extends JBaseApi {
    public settingsSave(
        payload: { menu: string[] },
        { signal }: { signal?: AbortSignal } = {},
    ): Promise<ApiWrapper<string[]>> {
        return this.network.post(
            {
                o: 'menu',
                f: 'settingsSave',
                ...payload,
            } as OF,
            signal,
        );
    }
}
